import { Component, Input, OnInit } from '@angular/core';
import { MobileAppRanking } from '../models/mobileAppRanking';
import { GroupType } from '../types/group-type';
import { MainFilterItem } from '../models/mainFilterItem';
import { Params } from '@angular/router';
import { GridHeader } from '../models/gridHeader';
import { User } from 'app/models/User';

@Component({ template: '' })
export abstract class DataWidgetComponent implements OnInit {
  @Input() data: MobileAppRanking;
  @Input() selectedGroup: GroupType | 'seller';
  @Input() mainFilterItems: MainFilterItem[];
  @Input() key: string;
  @Input() header: GridHeader;
  @Input() userService: User;
  @Input() reportId: string;

  platformName: string;
  discoveryType: string;
  region: string;
  month: string;
  country: string;

  insightsRouterLink: any[];
  discoveryRouterLink: any[];
  insightsQueryParamsRouterLink: Params;

  ngOnInit(): void {
    if (this.mainFilterItems) {
      this.platformName = this.getFilterValue('platformName');
      this.region = this.getFilterValueByLabel('Region');
      this.country = this.getFilterValueByLabel('Country');

      if (!this.region) {
        this.region = 'GLOBAL';
        this.country = 'GLOBAL';
      }

      const monthFilter = this.mainFilterItems.find(
        item => item.key === 'date'
      );
      if (monthFilter) {
        const monthSelected = monthFilter.selected;
        let month: string = monthSelected.value;
        if (new Date().getMonth() - parseInt(month.substring(4, 6)) >= 2) {
          month = monthFilter.options[0].value;
        }
        this.month = month.substring(0, 6);
      }
    }

    switch (this.selectedGroup) {
      case 'app':
        this.discoveryType = 'apps';
        this.insightsRouterLink = [
          '/insight',
          'apps',
          this.data?.appId,
          this.region,
          this.platformName || this.data?.platformName,
          'GLOBAL'
        ];
        this.insightsQueryParamsRouterLink = {
          country: this.country,
          month: this.month
        };

        this.discoveryRouterLink = [
          '/discovery',
          'apps',
          'list',
          this.platformName || this.data?.platformName,
          'GLOBAL',
          this.region
        ];
        break;
      case 'ctv':
        this.discoveryType = 'ctv';
        this.insightsRouterLink = [
          '/insight',
          'ctv',
          this.data?.appId,
          this.region,
          this.platformName || this.data?.platformName
        ];
        this.insightsQueryParamsRouterLink = {
          country: this.country
        };

        if (this.reportId !== 'mfaIndex') {
          this.insightsQueryParamsRouterLink.month = this.month;
        }

        this.discoveryRouterLink = [
          '/discovery',
          'ctv',
          'list',
          this.platformName || this.data?.platformName,
          this.region,
          'GLOBAL'
        ];
        break;
      case 'domain':
        this.discoveryType = 'domains';
        break;
      default:
        break;
    }
  }

  getFilterValue(key: string): string {
    const filterItem = this.mainFilterItems.find(item => item.key === key);
    return filterItem?.selected?.value as string;
  }

  getFilterValueByLabel(label: string): string {
    const filterItem = this.mainFilterItems.find(item => item.label === label);
    return filterItem?.selected?.value as string;
  }
}
